import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { memberUpdate, createMember} from '../../actions/memberActions'
import { useDispatch } from "react-redux";
import { Modal,Button } from 'react-bootstrap';
import PhoneInput from 'react-phone-number-input';
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { VALIDATE_EMAIL, VALIDATE_CONTACT_NO, VALIDATE_NAME } from '../../constants/constants'

const AddMemberModal = (props) => {

    const dispatch = useDispatch();

	const validationSchema = yup.object().shape({
		first_name: yup.string().required('First Name is requied')
			.min(3, 'First name should be greater than 3')
			.max(15, 'First name should be less than 15')
			.matches(VALIDATE_NAME, "Only alphabates are allowed for this field")
			.test('first_name', 'First name is required', (value) => value?.trim()),
		last_name: yup.string().required('Last Name is requied').min(3, 'Last name should be greater than 3')
			.max(15, 'Last name should be less than 15')
			.matches(VALIDATE_NAME, "Only alphabates are allowed for this field")
			.test('last_name', 'Last name is required', (value) => value?.trim()),
		contact_no: yup.string().required('Mobile Number is requied').matches(VALIDATE_CONTACT_NO, "Enter valid mobile number"),
		email: yup.string().required('Email is required').matches(VALIDATE_EMAIL, "Email is invalid"),
		designation: yup.string().required('Designation is required').matches(VALIDATE_NAME, "Designation is invalid"),
	});
	const { register, handleSubmit, reset, setValue, formState: { errors, ...formState }} = useForm({
		mode: "onBlur",
		resolver: yupResolver(validationSchema),
	}),
	[inputMemberFirstName, setInputMemberFirstName] = useState(""),
	[inputMemberLastName, setInputMemberLastName] = useState(""),
	[inputMemberEmail, setInputMemberEmail] = useState(""),
	[inputContactNo, setInputContactNo] = useState(""),
	[inputMemberTitle, setInputMemberTitle] = useState(""),
	[inputEdit, setInputEdit] = useState(""),
	// [inputPassword, setInputPassword] = useState(""),
	// [inputConfirmPassword, setInputConfirmPassword] = useState(""),
	[inputDesignation, setInputDesignation] = useState("");

	const { isValid } = formState

	const onAdminSubmit = async (values, e) => {
		//console.log("Form values", props.data);
		//values.type = "members";
		if (props.data) {
			values.id = (props.data !== false) ? props.data.userId : ''
		}
		//console.log("values", values);
		// const adminResponse = (props.data.mode && props.data.mode === "edit") ? dispatch(memberUpdate(values)) :  dispatch(createMember(values));;
		(props.data.mode && props.data.mode === "edit") ? dispatch(memberUpdate(values)) :  dispatch(createMember(values));;
		props.close();
		props.onLoad();
		
	};

	useEffect(() => {
		//console.log("my props", props);
		if (props.data && props.data.mode === "edit") {
			setValue('first_name', props.data.first_name)
			setValue('last_name', props.data.last_name)
			setValue('email', props.data.email)
			setValue('contact_no', props.data.contact_no)
			setValue('designation', props.data.designation)
			setInputMemberEmail(props.data.email);
			setInputMemberFirstName(props.data.first_name);
			setInputMemberLastName(props.data.last_name);
			setInputContactNo(props.data.contact_no);
			setInputDesignation(props.data.designation);
			setInputMemberTitle("Edit Member");
			setInputEdit("edit");
			//reset();
		} else {
			//console.log("within add");
			setValue('first_name', '')
			setValue('last_name', '')
			setValue('email', '')
			setValue('contact_no', '')
			setValue('designation', '')
			setInputMemberEmail("");
			setInputMemberFirstName("");
			setInputMemberLastName("");
			setInputContactNo("");
			setInputDesignation("");
			setInputEdit("add");
			setInputMemberTitle("Add New Member");
		}
	 }, [props, reset, setValue]);
	
	return (
		props.open && (
			<Modal show={props.open} onHide={props.close}>
                <Modal.Header>
                    <Modal.Title id="contained-modal-title">{inputMemberTitle}</Modal.Title>
					<Button variant="outline-danger" onClick={props.close}><i className="fa fa-close"></i></Button>
                </Modal.Header>
                <Modal.Body>
                    <div className="col-md-12">
						<form className="needs-validation" onSubmit={handleSubmit(onAdminSubmit)}>
							<div className="modal-body">
								<div className="form-group">
									<label>Name<span className="text-danger">*</span></label>
									<input
									  type="text"
									  className="form-control"
									  placeholder="Enter First Name"
									  tabIndex={1}
									  defaultValue={inputMemberFirstName}
									  onChange={(e) => setInputMemberFirstName(e.target.value)}
									  name="fullName"
									  autoComplete="off"
									  {...register('first_name')} 
									/>	
									{errors.first_name && (
									<div className="text-danger">{errors.first_name.message}</div>
									)}
								</div>
								<div className="form-group">
									<label htmlFor="text-input2">Last Name<span className='text-danger'>*</span></label>
									<input type="text" id="text-input2" 
										defaultValue={inputMemberLastName}
										onChange={(e) => setInputMemberLastName(e.target.value)}
										placeholder="Enter Last Name"
										{...register('last_name')}
										name="last_name"
										className="form-control" required />
									{errors.last_name && (
										<div className="text-danger">{errors.last_name.message}</div>
									)}
								</div>
								<div className="form-group">
									<label>Email<span className="text-danger">*</span></label>
									<input
										type="text"
										className="form-control"
										name="email"
										placeholder="Email Address"
										tabIndex={2}
										defaultValue={inputMemberEmail}
									    onChange={(e) => setInputMemberEmail(e.target.value)}
										{...register('email')}
										autoComplete="off"
									/>
									{errors.email && (
										<div className="text-danger">{errors.email.message}</div>
									)}
							  	</div>
								  <div className="form-group">
									<label>designation<span className="text-danger">*</span></label>
									<input
										type="text"
										className="form-control"
										name="designation"
										placeholder="Enter designation"
										tabIndex={3}
										defaultValue={inputDesignation}
									    onChange={(e) => setInputDesignation(e.target.value)}
										{...register('designation')}
										/>
							
										{errors.designation && (
											<div className="text-danger">{errors.designation.message}</div>
										)}
								</div>
								<div className="form-group">
									<label htmlFor="text-input4">Mobile no<span className='text-danger'>*</span></label>
									<PhoneInput
                                        className="form-control"
                                        defaultCountry="AU"
                                        countries={["AU"]}
                                        placeholder="Enter contact number"
                                        name="contact_no"
										{...register('contact_no')}
                                        value={inputContactNo} 
                                        onChange={(e) => setInputContactNo(e)}
                                    />
									{errors.contact_no && (
										<div className="text-danger pt-2">{errors.contact_no.message}</div>
									)}
								</div>
							</div>  
							<div className="modal-footer">
								<button type="submit" className="btn button"  disabled={(props.data.mode !=='edit') && isValid}>Submit</button>
								<button type="button" className="btn btn-outline-white" data-dismiss="modal" onClick={props.close}>Cancel</button>
								{inputEdit === "edit" ? <button type="button" className="btn btn-outline-danger px-3 py-2 ml-auto" onClick={(e) => { if (window.confirm('Are you sure you wish to delete this item?')) props.deleteData(e) } }>Delete</button> : ''}
							</div>
						</form>
                    </div>
                </Modal.Body>
                {/* <Modal.Footer>
                    <Button onClick={props.close}>Close</Button>
                </Modal.Footer> */}
            </Modal> 
		)
	);
}

export default AddMemberModal;
